import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

export type FormType = "announcement";

export const fields: any = {
  tender: drilldownData["tender"].map(
    ({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
    })
  ),
};
